<script setup lang="ts"></script>

<template>
  <div class="error-wall load-error">
    <div class="error-container">
      <h1>oh no...</h1>
      <h3>We have had an error</h3>
      <h4>Error 404</h4>
      <p>Sorry...please check back (click refresh) in just a moment.</p>
    </div>
  </div>
</template>
